var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: "smile_svg___icon_7rbmn_1",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "smile_svg__Pain smile_svg__free smile_svg__24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "smile_svg__SVG"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC220",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Z",
    className: "smile_svg__Fill-Main"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M10 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-4.707 6.293a1 1 0 0 1 1.414 0 7.485 7.485 0 0 0 10.586 0 1 1 0 0 1 1.414 1.414 9.485 9.485 0 0 1-13.414 0 1 1 0 0 1 0-1.414ZM16 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    className: "smile_svg__Fill-Secondary",
    clipRule: "evenodd"
  })))));
};
export default SvgSmile;